<template>
    <div class="rooms">
        <div class="page-header">
            <h1>
                Rooms

                <small>
                    &nbsp;
                    <button class="btn btn-default btn-fill btn-sm">
                        <span class="fa fa-plus fa-fw"></span>
                        Add new
                    </button>
                </small>
            </h1>
        </div>

        <loader v-if="!hasLoaded"></loader>

        <ul class="list-group" v-else>
            <router-link :to="{name: 'rooms.view', params: {id: room.id}}" class="list-group-item navigatable" v-for="room in rooms" :key="room.id">
                {{room.title}}
                <span class="pe-7s-angle-right-circle pull-right action"></span>
            </router-link>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
    .rooms {
        .list-group {
            .list-group-item {
                padding: 25px;

                .action {
                    color: #828282;
                    font-size: 25px;
                }

                &:hover,
                &.navigation-selected-active {
                    color: #555;
                    text-decoration: none;
                    background-color: #f5f5f5;

                    .action {
                        color: #ff3d70;
                    }
                }
            }
        }
    }
</style>

<script>
    import Loader from '@/components/layout/Loader'

    const RoomService = require('@/services/rooms/RoomService')

    export default {
        data() {
            return {
                rooms: [],
                hasLoaded: false
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                RoomService.findAll({
                    sort: [{
                        key: 'order',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.rooms = data.rows
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// Rooms.vue?6ba5e2a8